<template>

  <div class="fill-height" style="padding: 0 1px 1px 0">
    <slot />
  </div>

</template>
